import React from "react";
import {
  Paper,
  Grid,
  Typography,
  makeStyles,
  Theme,
  createStyles,
} from "@material-ui/core";
import useLanguage from "../../hooks/useLanguage";

interface IDBSourcesProps {}

export const DBSources: React.FC<IDBSourcesProps> = () => {
  const classes = useStyles();
  const { language } = useLanguage();
  const { translate } = language;
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Grid container justify="center" alignItems="center">
          <Grid item md={2}>
            <img src="/images/db_source/brockhaus.png" alt="brockhaus" />
          </Grid>
          <Grid item md={7}>
            <Typography component="p" className={classes.title}>
              Brockhaus
            </Typography>
            <Typography component="p" className={classes.subtitle}>
              Encyclopedia
            </Typography>
          </Grid>
          <Grid item md={3}>
            <Typography className={classes.secondary}>
              {translate.coming_soon}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.paper}>
        <Grid container justify="center" alignItems="center">
          <Grid item md={2}>
            <img src="/images/db_source/presseportal.png" alt="presseportal" />
          </Grid>
          <Grid item md={7}>
            <Typography component="p" className={classes.title}>
              Presseportal
            </Typography>
            <Typography component="p" className={classes.subtitle}>
              {translate.media}
            </Typography>
          </Grid>
          <Grid item md={3}>
            <Typography className={classes.secondary}>
              {translate.coming_soon}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.paper}>
        <Grid container justify="center" alignItems="center">
          <Grid item md={2}>
            <img src="/images/db_source/destatis.png" alt="destatis" />
          </Grid>
          <Grid item md={7}>
            <Typography component="p" className={classes.title}>
              DeStatis
            </Typography>
            <Typography component="p" className={classes.subtitle}>
              {translate.statistics}
            </Typography>
          </Grid>
          <Grid item md={3}>
            <Typography className={classes.secondary}>
              {translate.coming_soon}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.paper}>
        <Grid container justify="center" alignItems="center">
          <Grid item md={2}>
            <img src="/images/db_source/statista.png" alt="statista" />
          </Grid>
          <Grid item md={7}>
            <Typography component="p" className={classes.title}>
              Statista
            </Typography>
            <Typography component="p" className={classes.subtitle}>
              {translate.statistics}
            </Typography>
          </Grid>
          <Grid item md={3}>
            <Typography className={classes.secondary}>
              {translate.coming_soon}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      paddingTop: "30px",
    },
    paper: {
      padding: "10px",
      paddingLeft: "20px",
      border: "0.6px solid #E6E6E6",
      boxSizing: "border-box",
      boxShadow: "3px 3px 30px rgba(0, 0, 0, 0.15)",
      borderRadius: "8px",
      margin: "20px 0",
    },
    title: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "30px",
      color: "#333333",
    },
    subtitle: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "13px",
      lineHeight: "30px",
      color: "#5C5E63",
    },
    secondary: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "30px",
      color: "#A6A6A6",
    },
  })
);
